export const DASHBOARD = {
  page: "dashboard-page",
  upcomingWidget: "dashboard-upcoming-widget",
  upcomingBirthdaysList: "dashboard-upcoming-birthdays",
  upcomingAnniversariesList: "dashboard-upcoming-anniversaries",
  upcomingBirthdayItem: (id) => `dashboard-upcoming-birthday-${id}`,
  upcomingAnniversaryItem: (id) => `dashboard-upcoming-anniversary-${id}`,
};

export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  passwordToggle: "auth-password-toggle",
  pinInput: "auth-pin-input",
  pinSubmit: "auth-pin-submit",
  pinBack: "auth-pin-back",
  submitButton: "auth-submit-button",
  errorMsg: "auth-error-msg",
  logoutButton: "auth-logout-button",
};

export const LAYOUT = {
  sidebar: "layout-sidebar",
  navDashboard: "nav-dashboard",
  navMembers: "nav-members",
  navCapture: "nav-capture",
  navExpenses: "nav-expenses",
  navCells: "nav-cells",
  navReports: "nav-reports",
  navConsolidation: "nav-consolidation",
  navUsers: "nav-users",
  navRequests: "nav-requests",
  navAgenda: "nav-agenda",
  navKoinonia: "nav-koinonia",
  userBadge: "user-badge",
  userRoleBadge: "user-role-badge",
  myProfileButton: "my-profile-button",
  changePasswordModal: "change-password-modal",
  currentPasswordInput: "current-password-input",
  newPasswordInput: "new-password-input",
  changePasswordSubmit: "change-password-submit",
  changePasswordCancel: "change-password-cancel",
  changePasswordError: "change-password-error",
  changePasswordSuccess: "change-password-success",
  securityPinButton: "security-pin-button",
  pinModal: "security-pin-modal",
  pinModalError: "security-pin-error",
  pinModalSuccess: "security-pin-success",
  pinCurrentPassword: "security-pin-current-password",
  pinInput: "security-pin-input",
  pinConfirmInput: "security-pin-confirm-input",
  pinSave: "security-pin-save",
  pinDisable: "security-pin-disable",
  pinPromptBanner: "pin-prompt-banner",
  pinPromptActivate: "pin-prompt-activate",
  pinPromptDismiss: "pin-prompt-dismiss",
  backupReminderBanner: "backup-reminder-banner",
  backupReminderDownload: "backup-reminder-download",
  backupReminderSnooze: "backup-reminder-snooze",
};

export const USERS = {
  page: "users-page",
  table: "users-table",
  row: (id) => `users-row-${id}`,
  addButton: "users-add-button",
  formModal: "users-form-modal",
  emailInput: "users-email-input",
  passwordInput: "users-password-input",
  roleSelect: "users-role-select",
  saveButton: "users-save-button",
  cancelButton: "users-cancel-button",
  deleteButton: (id) => `users-delete-${id}`,
  resetPwdButton: (id) => `users-reset-pwd-${id}`,
  resetPinButton: (id) => `users-reset-pin-${id}`,
  resetPasswordInput: "users-reset-password-input",
  resetPasswordSubmit: "users-reset-password-submit",
  changeEmailButton: (id) => `users-change-email-${id}`,
  changeEmailInput: "users-change-email-input",
  changeEmailSubmit: "users-change-email-submit",
  errorMsg: "users-error-msg",
  infoMsg: "users-info-msg",
};

export const LOGIN_LOG = {
  section: "login-log-section",
  table: "login-log-table",
  refresh: "login-log-refresh",
  resultFilter: "login-log-result-filter",
  emailFilter: "login-log-email-filter",
};

export const EMAIL_TEMPLATES = {
  section: "email-templates-section",
  tab: (key) => `email-templates-tab-${key}`,
  subjectInput: "email-templates-subject-input",
  bodyInput: "email-templates-body-input",
  variableChip: (name) => `email-templates-var-${name}`,
  saveButton: "email-templates-save",
  resetButton: "email-templates-reset",
  previewButton: "email-templates-preview",
  testSendButton: "email-templates-test-send",
  previewModal: "email-templates-preview-modal",
  previewSubject: "email-templates-preview-subject",
  previewBody: "email-templates-preview-body",
  previewClose: "email-templates-preview-close",
  infoMsg: "email-templates-info",
  errorMsg: "email-templates-error",
  assistant: "email-templates-assistant",
  assistantUsedChip: (name) => `email-templates-assistant-used-${name}`,
  assistantUnknownChip: (name) => `email-templates-assistant-unknown-${name}`,
  assistantUnusedChip: (name) => `email-templates-assistant-unused-${name}`,
};

export const MAILTO_LOG = {
  section: "mailto-log-section",
  filterTemplate: "mailto-log-filter-template",
  filterSince: "mailto-log-filter-since",
  refresh: "mailto-log-refresh",
  table: "mailto-log-table",
  emptyRow: "mailto-log-empty",
  row: (id) => `mailto-log-row-${id}`,
  deleteButton: (id) => `mailto-log-delete-${id}`,
  errorMsg: "mailto-log-error",
};

export const PASTORAL_STATS = {
  section: "pastoral-stats-section",
  monthInput: "pastoral-stats-month",
  refresh: "pastoral-stats-refresh",
  exportPdf: "pastoral-stats-export-pdf",
  kpiEmailsTotal: "pastoral-stats-kpi-emails-total",
  kpiReminders: "pastoral-stats-kpi-reminders",
  kpiRequestsTotal: "pastoral-stats-kpi-requests-total",
  kpiApproved: "pastoral-stats-kpi-approved",
  topList: "pastoral-stats-top-list",
  topRow: (i) => `pastoral-stats-top-row-${i}`,
  emptyTop: "pastoral-stats-top-empty",
  reminderBanner: "pastoral-stats-reminder-banner",
  reminderSend: "pastoral-stats-reminder-send",
  reminderDismiss: "pastoral-stats-reminder-dismiss",
};

export const CONSOLIDATION = {
  page: "consolidation-page",
  tabVisitors: "consolidation-tab-visitors",
  tabConverts: "consolidation-tab-converts",
  tabFollowup: "consolidation-tab-followup",
  tabLadder: "consolidation-tab-ladder",
  tabBaptisms: "consolidation-tab-baptisms",

  // Visitors / Converts tables
  addButton: "consolidation-add-button",
  searchInput: "consolidation-search-input",
  stageFilter: "consolidation-stage-filter",
  table: "consolidation-table",
  row: (id) => `consolidation-row-${id}`,
  editButton: (id) => `consolidation-edit-${id}`,
  deleteButton: (id) => `consolidation-delete-${id}`,
  advanceButton: (id) => `consolidation-advance-${id}`,
  followupButton: (id) => `consolidation-followup-${id}`,
  greetingButton: (id) => `consolidation-greeting-${id}`,
  greetingBadge: (id) => `consolidation-greeting-badge-${id}`,

  // Greeting template editor
  templateSection: "greeting-template-section",
  templateInput: "greeting-template-input",
  templateSaveButton: "greeting-template-save",
  templateResetButton: "greeting-template-reset",
  templateInfoMsg: "greeting-template-info",

  // 48h follow-up reminder
  reminderSection: "reminder-section",
  reminderEnableToggle: "reminder-enable-toggle",
  reminderPhoneInput: "reminder-phone-input",
  reminderSaveButton: "reminder-save-button",
  reminderRunNowButton: "reminder-run-now-button",
  reminderPreviewButton: "reminder-preview-button",
  reminderInfoMsg: "reminder-info-msg",
  reminderErrorMsg: "reminder-error-msg",
  reminderStats: "reminder-stats",

  // Person form modal
  formModal: "consolidation-form-modal",
  fullNameInput: "consolidation-full-name",
  phoneInput: "consolidation-phone",
  addressInput: "consolidation-address",
  firstVisitInput: "consolidation-first-visit",
  invitedByInput: "consolidation-invited-by",
  cellSelect: "consolidation-cell-select",
  notesInput: "consolidation-notes",
  saveButton: "consolidation-save",
  cancelButton: "consolidation-cancel",
  errorMsg: "consolidation-error",

  // Advance modal
  advanceModal: "consolidation-advance-modal",
  advanceStageSelect: "consolidation-advance-stage",
  advanceDateInput: "consolidation-advance-date",
  advanceNotesInput: "consolidation-advance-notes",
  advanceOfficiantInput: "consolidation-advance-officiant",
  advanceLocationInput: "consolidation-advance-location",
  advanceConfirm: "consolidation-advance-confirm",

  // Followup
  followupModal: "consolidation-followup-modal",
  followupPersonName: "consolidation-followup-name",
  taskCheckbox: (key) => `consolidation-task-${key}`,
  taskNotesInput: (key) => `consolidation-task-notes-${key}`,
  followupClose: "consolidation-followup-close",
  followupCard: (id) => `consolidation-followup-card-${id}`,

  // Ladder
  ladderColumn: (stage) => `consolidation-ladder-col-${stage}`,
  ladderCount: (stage) => `consolidation-ladder-count-${stage}`,

  // Baptisms
  baptismsFromInput: "baptisms-from",
  baptismsToInput: "baptisms-to",
  baptismsGenerate: "baptisms-generate",
  baptismsPdfButton: "baptisms-pdf",
  baptismsTable: "baptisms-table",
  baptismsRow: (id) => `baptisms-row-${id}`,
  baptismsTotal: "baptisms-total",
};

export const CELLS = {
  page: "cells-page",
  // Stats
  statTotal: "cells-stat-total",
  statActive: "cells-stat-active",
  statMembers: "cells-stat-members",
  statAnnualOffering: "cells-stat-annual-offering",
  statMonthOffering: "cells-stat-month-offering",
  yearSelect: "cells-year-select",
  monthSelect: "cells-month-select",
  // Search
  searchInput: "cells-search-input",
  searchResult: (id) => `cells-search-result-${id}`,
  newCellButton: "cells-new-button",
  // Cell form (vertical)
  form: "cell-form",
  formError: "cell-form-error",
  nameInput: "cell-form-name",
  leaderInput: "cell-form-leader",
  subleaderInput: "cell-form-subleader",
  supportInput: "cell-form-support",
  scheduleInput: "cell-form-schedule",
  addressInput: "cell-form-address",
  countyInput: "cell-form-county",
  notesInput: "cell-form-notes",
  activeToggle: "cell-form-active",
  formSave: "cell-form-save",
  formCancel: "cell-form-cancel",
  // Cell record (vertical)
  record: "cell-record",
  recordEdit: "cell-record-edit",
  recordDelete: "cell-record-delete",
  recordClose: "cell-record-close",
  // Capture form
  capForm: "cell-capture-form",
  capDate: "cell-capture-date",
  capField: (key) => `cell-capture-${key}`,
  capOffering: "cell-capture-offering",
  capNotes: "cell-capture-notes",
  capSave: "cell-capture-save",
  capCancelEdit: "cell-capture-cancel-edit",
  // Captures list
  capYearSelect: "cell-captures-year",
  capMonthSelect: "cell-captures-month",
  capTotals: "cell-captures-totals",
  printButton: "cell-record-print",
  capList: "cell-captures-list",
  capItem: (id) => `cell-capture-item-${id}`,
  capEdit: (id) => `cell-capture-edit-${id}`,
  capDelete: (id) => `cell-capture-delete-${id}`,
  // Growth chart (Phase H)
  growthSection: "cells-growth-section",
  growthToggle: "cells-growth-toggle",
  growthYearSelect: "cells-growth-year",
  growthTabLine: "cells-growth-tab-line",
  growthTabBar: "cells-growth-tab-bar",
  growthChart: "cells-growth-chart",
  growthEmpty: "cells-growth-empty",
  growthCountyFilter: "cells-growth-county-filter",
};

export const MEMBERS = {
  page: "members-page",
  addButton: "members-add-button",
  saveButton: "members-save-button",
  cancelButton: "members-cancel-button",
  table: "members-table",
  row: (id) => `member-row-${id}`,
  editButton: (id) => `member-edit-${id}`,
  deleteButton: (id) => `member-delete-${id}`,
  nameInput: "member-name-input",
  emailInput: "member-email-input",
  phoneInput: "member-phone-input",
  statusSelect: "member-status-select",
  ministrySelect: "member-ministry-select",
  demographicSelect: "member-demographic-select",
  cellSelect: "member-cell-select",
  joinDateInput: "member-joindate-input",
  birthdateInput: "member-birthdate-input",
  notesInput: "member-notes-input",
  searchInput: "members-search-input",
  downloadPdfButton: "members-download-pdf",
  downloadExcelButton: "members-download-excel",
  statVarones: "members-stat-varones",
  statMujeres: "members-stat-mujeres",
  statJovenes: "members-stat-jovenes",
  statNinos: "members-stat-ninos",
};

export const CAPTURE = {
  page: "capture-page",
  monthSelect: "capture-month-select",
  yearSelect: "capture-year-select",
  addRowButton: "capture-add-row",
  saveAllButton: "capture-save-all",
  table: "capture-table",
  row: (id) => `capture-row-${id}`,
  tithesInput: (id) => `capture-tithes-${id}`,
  offeringInput: (id) => `capture-offering-${id}`,
  specialInput: (id) => `capture-special-${id}`,
  adultsInput: (id) => `capture-adults-${id}`,
  youthInput: (id) => `capture-youth-${id}`,
  kidsInput: (id) => `capture-kids-${id}`,
  notesInput: (id) => `capture-notes-${id}`,
  deleteButton: (id) => `capture-delete-${id}`,
  envelopesButton: (id) => `capture-envelopes-${id}`,
  totalsRow: "capture-totals-row",
};

export const ENVELOPES = {
  modal: "envelopes-modal",
  table: "envelopes-table",
  row: (id) => `envelope-row-${id}`,
  addButton: "envelopes-add-button",
  memberSelect: "envelopes-member-select",
  memberSearchInput: "envelopes-member-search-input",
  memberSuggestionsList: "envelopes-member-suggestions",
  memberSuggestionItem: (id) => `envelopes-member-suggestion-${id}`,
  memberClearButton: "envelopes-member-clear-button",
  memberSelectedBadge: "envelopes-member-selected-badge",
  visitorInput: "envelopes-visitor-input",
  typeSelect: "envelopes-type-select",
  amountInput: "envelopes-amount-input",
  notesInput: "envelopes-notes-input",
  deleteButton: (id) => `envelopes-delete-${id}`,
  closeButton: "envelopes-close-button",
  totalDiezmos: "envelopes-total-diezmos",
  totalOfrendas: "envelopes-total-ofrendas",
  mismatchWarning: "envelopes-mismatch-warning",
  generateDiezmosButton: "envelopes-generate-diezmos-button",
  generateOfrendasButton: "envelopes-generate-ofrendas-button",
  applySuccessMsg: "envelopes-apply-success-msg",
};

export const REPORTS = {
  page: "reports-page",
  tabMonthly: "reports-tab-monthly",
  tabMember: "reports-tab-member",
  tabAnnual: "reports-tab-annual",
  tabMultiYear: "reports-tab-multiyear",
  tabCells: "reports-tab-cells",
  tabImport: "reports-tab-import",
  multiYearAdd: "reports-multiyear-add",
  multiYearRemove: (idx) => `reports-multiyear-remove-${idx}`,
  multiYearYearSelect: (idx) => `reports-multiyear-year-${idx}`,
  multiYearGenerate: "reports-multiyear-generate",
  multiYearDownloadPdf: "reports-multiyear-download-pdf",
  multiYearChartBalance: "reports-multiyear-chart-balance",
  multiYearChartIngresosGastos: "reports-multiyear-chart-ingresos-gastos",
  monthSelect: "reports-month-select",
  yearSelect: "reports-year-select",
  memberSelect: "reports-member-select",
  annualYearSelect: "reports-annual-year-select",
  generateButton: "reports-generate-button",
  downloadPdfButton: "reports-download-pdf",
  downloadExcelButton: "reports-download-excel",
  downloadExcelMonthlyButton: "reports-download-excel-monthly",
  downloadExcelAnnualButton: "reports-download-excel-annual",
  downloadAnnualBundleButton: "reports-download-annual-bundle",
  downloadBoardPdfButton: "reports-download-board-pdf",
  preview: "reports-preview",
  memberDetailTable: "reports-member-detail-table",
  memberDetailRow: (id) => `reports-member-detail-row-${id}`,
  memberDetailToggle: "reports-member-detail-toggle",
  errorMsg: "reports-error-msg",
  // Cells / Per-Cell report
  cellsYearSelect: "reports-cells-year-select",
  cellsMonthSelect: "reports-cells-month-select",
  cellsGenerateButton: "reports-cells-generate",
  cellsDownloadPdfButton: "reports-cells-download-pdf",
  cellsTable: "reports-cells-table",
  cellsRow: (id) => `reports-cells-row-${id}`,
  cellsMonthlyMatrix: "reports-cells-monthly-matrix",
  cellsTopChart: "reports-cells-top-chart",
  cellsTopToggleAttendance: "reports-cells-top-toggle-attendance",
  cellsTopToggleOffering: "reports-cells-top-toggle-offering",
  cellsDownloadXlsxButton: "reports-cells-download-xlsx",
  // Print buttons (browser print, no save)
  printButton: "reports-print-button",
  multiYearPrintButton: "reports-multiyear-print",
  cellsPrintButton: "reports-cells-print",
};

export const IMPORT = {
  panel: "import-panel",
  membersFileInput: "import-members-file-input",
  membersUploadButton: "import-members-upload-button",
  membersTemplateButton: "import-members-template-button",
  membersResult: "import-members-result",
  membersError: "import-members-error",
  capturesFileInput: "import-captures-file-input",
  capturesUploadButton: "import-captures-upload-button",
  capturesTemplateButton: "import-captures-template-button",
  capturesResult: "import-captures-result",
  capturesError: "import-captures-error",
  expensesFileInput: "import-expenses-file-input",
  expensesUploadButton: "import-expenses-upload-button",
  expensesTemplateButton: "import-expenses-template-button",
  expensesResult: "import-expenses-result",
  expensesError: "import-expenses-error",
};

export const BACKUP = {
  openButton: "backup-open-button",
  modal: "backup-modal",
  downloadButton: "backup-download-button",
  fileInput: "backup-file-input",
  replaceToggle: "backup-replace-toggle",
  restoreButton: "backup-restore-button",
  closeButton: "backup-close-button",
  summary: "backup-summary",
  errorMsg: "backup-error-msg",
  autoSection: "backup-auto-section",
  autoList: "backup-auto-list",
  autoRunNow: "backup-auto-run-now",
  autoDownload: (id) => `backup-auto-download-${id}`,
  autoRestore: (id) => `backup-auto-restore-${id}`,
  autoDelete: (id) => `backup-auto-delete-${id}`,
};

export const EXPENSES = {
  page: "expenses-page",
  monthSelect: "expenses-month-select",
  yearSelect: "expenses-year-select",
  addRowButton: "expenses-add-row",
  saveAllButton: "expenses-save-all",
  table: "expenses-table",
  row: (id) => `expense-row-${id}`,
  dateInput: (id) => `expense-date-${id}`,
  categorySelect: (id) => `expense-category-${id}`,
  descriptionInput: (id) => `expense-description-${id}`,
  amountInput: (id) => `expense-amount-${id}`,
  methodSelect: (id) => `expense-method-${id}`,
  deleteButton: (id) => `expense-delete-${id}`,
  totalsRow: "expenses-totals-row",
  exportXlsxButton: "expenses-export-xlsx",
};

export const BUDGETS = {
  panel: "budgets-panel",
  toggle: "budgets-toggle",
  saveButton: "budgets-save-all",
  alertsBanner: "budgets-alerts-banner",
  row: (category) => `budget-row-${category}`,
  amountInput: (category) => `budget-amount-${category}`,
  bar: (category) => `budget-bar-${category}`,
  consumed: (category) => `budget-consumed-${category}`,
  percentage: (category) => `budget-percentage-${category}`,
  level: (category) => `budget-level-${category}`,
  totalsRow: "budgets-totals-row",
  warningInput: "budgets-threshold-warning",
  criticalInput: "budgets-threshold-critical",
  thresholdsSave: "budgets-threshold-save",
  thresholdsFlash: "budgets-threshold-flash",
};

export const REQUESTS = {
  page: "requests-page",
  addButton: "requests-add-button",
  filterStatus: "requests-filter-status",
  filterType: "requests-filter-type",
  table: "requests-table",
  row: (id) => `requests-row-${id}`,
  editButton: (id) => `requests-edit-${id}`,
  deleteButton: (id) => `requests-delete-${id}`,
  approveButton: (id) => `requests-approve-${id}`,
  rejectButton: (id) => `requests-reject-${id}`,
  // form modal
  formModal: "requests-form-modal",
  typeSelect: "requests-type-select",
  titleInput: "requests-title-input",
  dateInput: "requests-date-input",
  timeInput: "requests-time-input",
  locationInput: "requests-location-input",
  reasonInput: "requests-reason-input",
  attendanceInput: "requests-attendance-input",
  budgetInput: "requests-budget-input",
  materialsInput: "requests-materials-input",
  responsibleInput: "requests-responsible-input",
  notesInput: "requests-notes-input",
  saveButton: "requests-save-button",
  cancelButton: "requests-cancel-button",
  errorMsg: "requests-error-msg",
  // decision modal
  decisionModal: "requests-decision-modal",
  decisionNotes: "requests-decision-notes",
  decisionApprove: "requests-decision-approve",
  decisionReject: "requests-decision-reject",
  statBadge: (status) => `requests-stat-${status}`,
};

export const AGENDA = {
  page: "agenda-page",
  tabTasks: "agenda-tab-tasks",
  tabDiary: "agenda-tab-diary",
  // tasks
  addTaskButton: "agenda-add-task-button",
  taskFilter: "agenda-task-filter",
  taskAssigneeFilter: "agenda-task-assignee-filter",
  taskList: "agenda-task-list",
  taskRow: (id) => `agenda-task-${id}`,
  taskCheckbox: (id) => `agenda-task-check-${id}`,
  taskEditButton: (id) => `agenda-task-edit-${id}`,
  taskDeleteButton: (id) => `agenda-task-delete-${id}`,
  // task modal
  taskModal: "agenda-task-modal",
  taskTitleInput: "agenda-task-title",
  taskDescInput: "agenda-task-desc",
  taskPrioritySelect: "agenda-task-priority",
  taskDueInput: "agenda-task-due",
  taskAssignSelect: "agenda-task-assign",
  taskStatusSelect: "agenda-task-status",
  taskSaveButton: "agenda-task-save",
  taskCancelButton: "agenda-task-cancel",
  // diary
  diaryDateInput: "agenda-diary-date-input",
  diaryUserSelect: "agenda-diary-user-select",
  diaryLogTextarea: "agenda-diary-log",
  diarySaveButton: "agenda-diary-save",
  diaryHistory: "agenda-diary-history",
  diaryEntry: (id) => `agenda-diary-entry-${id}`,
};

export const KOINONIA = {
  page: "koinonia-page",
  tabMovements: "koinonia-tab-movements",
  tabGroups: "koinonia-tab-groups",
  tabSummary: "koinonia-tab-summary",
  // header stats
  statEntradas: "koinonia-stat-entradas",
  statSalidas: "koinonia-stat-salidas",
  statBalance: "koinonia-stat-balance",
  // movements
  addMovementButton: "koinonia-add-movement",
  yearSelect: "koinonia-year-select",
  monthSelect: "koinonia-month-select",
  movementsTable: "koinonia-movements-table",
  movementRow: (id) => `koinonia-movement-${id}`,
  movementEditButton: (id) => `koinonia-movement-edit-${id}`,
  movementDeleteButton: (id) => `koinonia-movement-delete-${id}`,
  // movement form
  movementModal: "koinonia-movement-modal",
  movementDateInput: "koinonia-movement-date",
  movementTypeSelect: "koinonia-movement-type",
  movementAmountInput: "koinonia-movement-amount",
  movementContribTypeSelect: "koinonia-movement-contrib-type",
  movementContribNameInput: "koinonia-movement-contrib-name",
  movementGroupSelect: "koinonia-movement-group",
  movementDescInput: "koinonia-movement-desc",
  movementNotesInput: "koinonia-movement-notes",
  movementSaveButton: "koinonia-movement-save",
  movementCancelButton: "koinonia-movement-cancel",
  // groups
  addGroupButton: "koinonia-add-group",
  groupsList: "koinonia-groups-list",
  groupRow: (id) => `koinonia-group-${id}`,
  groupEditButton: (id) => `koinonia-group-edit-${id}`,
  groupDeleteButton: (id) => `koinonia-group-delete-${id}`,
  // group form
  groupModal: "koinonia-group-modal",
  groupNameInput: "koinonia-group-name",
  groupCollaboratorToggle: "koinonia-group-collaborator",
  groupRotationSelect: "koinonia-group-rotation",
  groupMembersInput: "koinonia-group-members",
  groupNotesInput: "koinonia-group-notes",
  groupSaveButton: "koinonia-group-save",
  groupCancelButton: "koinonia-group-cancel",
  // summary
  summaryYearSelect: "koinonia-summary-year",
  summaryMonthSelect: "koinonia-summary-month",
  summaryDownloadPdf: "koinonia-summary-download-pdf",
};
